import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NavigationLink } from '@coin/shared/core/util-helpers';

@Component({
  selector: 'coin-a-navigation-menu-wrapper',
  templateUrl: './navigation-menu-wrapper.component.html',
  styleUrls: ['./navigation-menu-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class NavigationMenuWrapperComponent {
  readonly disableNavigationLink = input<(link: NavigationLink) => boolean>(() => false);
}
